<template>
  <router-link to="/" class="lg:hidden">
    <div class="flex items-center justify-center gap-x-2">
      <img alt="Moroorato" class="h-9 w-9" src="/images/logo/logo.png" />
      <!-- §2.2: `text-xl` is the page <h1> and «`PageHeader.vue` only. No other file may write it.»
           §2.6's table sends every other site to `text-base`. `font-bold` is reserved for the metric
           slot (§2.3); a wordmark is a heading, so 600. -->
      <span class="text-base font-semibold text-brand-600 dark:text-white">{{ t('app.name') }}</span>
    </div>
  </router-link>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
